export default __webpack_public_path__ + "static/media/093-compress.7bf398d8.png";